// src/components/DragPreview/DragPreview.tsx
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../services/types/store-types';
import { Avatar } from 'primereact/avatar';
import styles from './drag-preview.module.css';
import { XYCoord } from 'react-dnd';

type DragPreviewProps = {
  offset: XYCoord | null;
  mouse: XYCoord | null;
  id: string | null;
  dragIds: string[];
  isDragging: boolean;
};

export const DragPreview: React.FC<DragPreviewProps> = ({
  offset,
  mouse,
  isDragging,
}) => {
  const canCreateNode = useSelector(
    (state: RootState) => state.tree.canCreateTreeLink
  );

  // Проверяем, что все необходимые данные присутствуют
  if (!isDragging || !mouse || !offset) {
    return null;
  }

  // Вычисляем позицию превью относительно курсора
  const style: React.CSSProperties = {
    position: 'fixed', // Фиксированное позиционирование относительно окна браузера
    top: mouse.y - 10, // Добавляем смещение для лучшего UX
    left: mouse.x + 10, // Добавляем смещение для лучшего UX
    height: 30,
    width: 30,
    minWidth: 30,
    pointerEvents: 'none', // Отключаем события мыши для превью
    zIndex: 1000, // Обеспечиваем, чтобы превью было поверх других элементов
    //transform: 'translate(-50%, -50%)', // Центрируем превью относительно позиции
  };

  return (
    <div style={style}>
      <Avatar
        icon={
          isDragging && Boolean(canCreateNode) ? 'pi pi-check' : 'pi pi-times'
        }
        className={Boolean(canCreateNode) ? styles.add : styles.delete}
        size="normal"
        shape="circle"
      />
    </div>
  );
};
// Compare this snippet from src/components/tree/node/node.tsx:
